'use strict';

import Swiper from 'swiper';

import Player from '@vimeo/player';

const SELECTOR = '.js-fade-gallery';

const isReducedMotion = window.matchMedia(`(prefers-reduced-motion: reduce)`) === true || window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;

function initialiseElement(element) {
    const pauseClass = 'concert-gallery--pause';
    const scrollerElement = element.querySelector('.swiper-container');
    const pauseButton = element.querySelector('.concert-gallery__button');
    const pauseButtonText = element.querySelector('.concert-gallery__button-text');

    const settings = {
        slidesPerView: '1',
        effect: 'fade',
        speed: 1500,
        fadeEffect: {
            crossFade: true
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        autoplay: {
           delay: 5000,
        },
        on: {
            slideChangeTransitionEnd: function () {
                let slides = document.querySelectorAll('.concert-gallery__slide');
                slides.forEach(slide => {
                    let iframe = slide.querySelector('iframe');
                    if (iframe) {
                        let player = new Player(iframe);
                        if (slide.classList.contains('swiper-slide-active')) {
                            player.play();
                            console.log('play')
                        } else {
                            player.pause();
                            console.log('pause')
                        }
                    }
                });
            }
        }
    };

    let swiper = new Swiper(scrollerElement, settings );

    let autoplayStatus = true;

    if (pauseButton) {
        pauseButton.addEventListener('click', () => {
            if(isGalleryPause && autoplayStatus){
                pausePlay();
            }else{
                startPlay();
            }
        }, false);
    }

    function isGalleryPause() {
        return element.classList.contains(pauseClass);
    }

    function startPlay(){
        swiper.autoplay.start();
        autoplayStatus = true;
        element.classList.remove(pauseClass);
        pauseButtonText.textContent = 'Pause';
    }

    function pausePlay(){
        swiper.autoplay.stop();
        autoplayStatus = false;
        element.classList.add(pauseClass);
        pauseButtonText.textContent = 'Play';
    }

    if (isReducedMotion) {
        swiper.autoplay.stop();
        autoplayStatus = false;
        element.classList.add(pauseClass);
    }

}

export function init() {
    document.querySelectorAll(SELECTOR).forEach(initialiseElement);
}

export default {
    init,
    initialiseElement
};
